<script lang="ts">
import { defineComponent } from 'vue';
import VueMarkdown from 'vue-markdown-render';
import { plugins } from '@/util/markdown-plugins';
import * as DocumentHelper from '@/util/document-helper';

export default defineComponent({
	name: 'CmsMarkdownDisplay',

	components: {
		VueMarkdown,
	},

	props: {
		markdown: {
			type: String,
			required: true,
		},
		openLinksInNewWindow: {
			type: Boolean,
		},
	},

	data() {
		return {};
	},

	computed: {
		plugins() {
			return plugins;
		},
	},

	methods: {
		onClick(e: PointerEvent) {
			let node = e.target as HTMLElement;
			if (!(node instanceof HTMLElement)) return;
			while (node.nodeName !== 'A') {
				if (!node.parentElement) return;
				node = node.parentElement;
			}
			e.preventDefault();
			e.stopPropagation();
			let url = node.getAttribute('href');
			if (!url) return;
			if (url.startsWith('#download=')) {
				DocumentHelper.downloadFromId(url.substring(10));
				return;
			}
			try {
				const targetUrl = new URL(url, window.location.origin);
				const isExternal = targetUrl.host !== window.location.host;
				if (isExternal || this.openLinksInNewWindow) {
					window.open(targetUrl.href, '_blank');
				} else {
					this.$router.push('/' + url);
				}
			} catch (err) {
				console.warn('Invalid URL in markdown link:', url, err);
			}
		},
	},
});
</script>

<template>
	<article class="cms-view">
		<VueMarkdown
			:source="markdown"
			:plugins="plugins"
			@click="onClick"
			:options="{ html: false, breaks: true }"
		/>
	</article>
</template>
